import {Component, HostBinding, HostListener, isDevMode, OnInit} from '@angular/core';
import {LanguageSwitcherComponent} from "../../../../i18n/language-switcher/language-switcher.component";
import {SystemStatus} from "../../system/system-status/system-status";
import {SystemStatusPollerService} from "../../system/system-status/system-status-poller.service";
import {take} from "rxjs/operators";
import {logAsync} from "../../../../helpers/logging";
import {ApiRouteConfig} from "../../../../config/api.route.config";
import {PermissionsService} from '../../../common/services/permissions-service';
import {Permission} from '../../../common/enums/enums';
import {MatDialog} from '@angular/material/dialog';
import {APP_VERSION} from '../../../../../version';
import {TokenService} from '../../../common/services/token.service';
import {parseJwt} from '../../../../helpers/jwt';
import {Environment} from "../../../../environment/environment";
import {EnvironmentLoader, Environments} from "../../../../environment/environment-loader.service";

/**
 * It's Probably The Backend's Fault Anyway 😆
 * Setting this key to "true" in the browser's local storage will force
 * enable the debug menu in production environments. Afterwards you
 * can trigger it with the corresponding keyboard shortcut.
 */
const OVERRIDE_KEY = 'IPTBFA';

@Component({
    selector: 'app-debug-menu',
    templateUrl: './debug-menu.component.html',
    styleUrls: ['./debug-menu.component.scss']
})
export class DebugMenuComponent implements OnInit {
    @HostBinding('class.active')
    public showing = false;

    public readonly isDevMode = isDevMode();
    protected readonly Environments = Environments;

    private readonly permissions$ = this.permissionsResource.getPermissions()
      .pipe();
  private permissions: Permission[];
  private permissionsByProduct: Permission[];

    constructor(
        private readonly dialogs: MatDialog,
        private readonly systemStatus: SystemStatus,
        private readonly statusPoller: SystemStatusPollerService,
        private readonly api: ApiRouteConfig,
        private readonly permissionsResource: PermissionsService,
        protected readonly token: TokenService,
        private readonly environment: Environment,
        private readonly environmentManager: EnvironmentLoader,
    ) {
        // @ts-ignore
        window.debugMenu = this
        this.trackPermissions();
    }

    public get enabled() {
        return forceEnabled() || this.isDevMode;
    }

    ngOnInit(): void {

    }

    public get pollingInterval() {
        return this.statusPoller.tick_interval;
    }

    @HostListener('window:keydown.escape')
    public hide() {
        if (this.showing) {
            this.showing = false;
        }
    }

    /**
     * OPENING THE DEBUG MENU
     */

    @HostListener('window:keydown.meta.control.escape')
    public show() {
        if (this.enabled) {
            return this.showing = true;
        }
        console.info('🚫 Prevented opening debug menu\nNot allowed in this environment. It\'s probably the backend\'s fault anyway.')
    }

    /**
     * CAPABILITY - Language Switching
     */
    public async openLanguageSwitcher() {
        console.group('Switching language');
        const switcher = this.dialogs.open(LanguageSwitcherComponent, {panelClass: 'full-bleed'});
        console.log('Language switcher opened')
        const language = await switcher.afterClosed().toPromise();
        console.log(
            language ? `Switched to language "${language}"` : 'Language switch aborted'
        );
        console.groupEnd();

    }

    /**
     * CAPABILITY - System Status
     */
    public logSystemStatus() {
        console.group('System Status')
        console.debug('Stored System Status', this.systemStatus);
        console.groupEnd();
    }

    public refreshSystemStatus() {
        console.group('System Status');
        console.log('Refreshing from server …')
        this.systemStatus.changes$.pipe(
            take(1), logAsync('Refreshed System Status')
        ).subscribe();
        this.statusPoller.refresh();
        console.groupEnd();
    }

    public logEnvironment() {
        console.group('Application environment');
        console.table(this.environment);
        console.groupEnd();
    }

    public logAPIEndoint() {
        // @ts-ignore
        const endpoints: [string, string][] = Object.entries(Object.getOwnPropertyDescriptors(ApiRouteConfig.prototype))
            .filter(([key, descriptor]) => typeof descriptor.get === 'function')
            .map(([key, descriptor]) => [key, this.api[key]]);
        console.table(endpoints);
    }

  public logPermissions() {
    console.table(this.permissions);
    console.table(this.permissionsByProduct);
  }

  private trackPermissions() {
      this.permissionsResource.getPermissions().subscribe(permissions => this.permissions = permissions);
      this.permissionsResource.getpermissionsByProduct().subscribe(permissionsByProduct => this.permissionsByProduct = permissionsByProduct);
  }

  protected readonly APP_VERSION = APP_VERSION;

  public dumpToken() {
    const token = this.token.getToken();
    const decodedToken = parseJwt(token);
    console.log(token);
    console.log(decodedToken);

  }

    public applyEnvironment(environment: Environments) {
        this.environmentManager.environmentOverride = environment;
        window.location.reload();
    }
}

function forceEnabled() {
    return localStorage.getItem(OVERRIDE_KEY);
}

